import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import COUNTRIES_QUERY from '../queries/COUNTRIES_QUERY';
 
const useCountries = () => {
    const [ countries, setCountries ] = useState( [] );
    const { data, loading, error } = useQuery( COUNTRIES_QUERY );
 
    useEffect( () => {
        if ( loading || error || !data || !data.countries?.edges ) { return; }
        
        try {
            const result = data.countries.edges.map( i => ( {
                key: i.node.id,
                ...i.node
            } ) );

            setCountries( result );
        } catch ( error ) {
            console.error( 'Error parsing countries', error ); 
            setCountries( [] );
        }
    }, [ loading, error ] );

    return useMemo( () => {
        return {
            countries,
            countriesError: error,
            countriesLoading: loading,
        };
    }, [ countries, error, loading ] );
};

export default useCountries;
